export default function CollectSuggestions({ suggestions, onSelect }) {
  return (
    <div className="Collect-suggestions" style={{ marginTop: "8px" }}>
      {suggestions.map((acc, idx) => (
        <div
          key={idx}
          className="Collect-suggestion-item"
          onClick={() => onSelect(acc)}
          style={{
            border: "1px solid red",
            padding: "10px",
            borderRadius: "6px",
            marginBottom: "6px",
            cursor: "pointer",
            backgroundColor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
          }}
        >
          <div style={{ fontWeight: "bold" }}>{acc.AccountNo}</div>
          <div style={{ fontSize: "14px", color: "#555" }}>{acc.Name}</div>
        </div>
      ))}
    </div>
  );
}
